<template>
  <div class="left-chart-2" id="left-chart-2"></div>
</template>

<script>
import { queryctlsbyxzlltop } from '@/api/modules/dataView.js'
export default {
  name: 'LeftChart2',
  props: {
    date: {
      type: Object,
      default: () => {
        return {
          startdate: '',
          enddate: '',
        }
      },
    },
  },
  data() {
    return {
      chart: null,
    }
  },
  mounted() {
    this.$nextTick(() => {
      const echartsDom = document.getElementById('left-chart-2')
      this.chart = this.$echarts.init(echartsDom)
      this.getData()
    })
  },
  methods: {
    async getData() {
      const apiData = await queryctlsbyxzlltop(this.date)
      let xDatas = []
      let chartsDatas = []
      apiData.forEach(item => {
        xDatas.push(item.hxcs_position)
        chartsDatas.push(item.yxsysc_yxsysc)
      })
      const options = {
        title: {
          text: 'CT类设备有效诊疗时间列表',
          left: 'center',
          textStyle: {
            color: '#fff',
          },
        },
        tooltip: {},
        grid: {
          top: 40,
          bottom: 40,
        },
        xAxis: [
          {
            type: 'category',
            axisLabel: {
              color: '#fff',
            },
            data: xDatas,
          },
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              color: '#fff',
            },
          },
        ],
        series: [
          {
            type: 'bar',
            barWidth: '20px',
            label: {
              show: true,
              position: 'inside',
            },
            data: chartsDatas,
          },
        ],
      }
      this.chart.setOption(options)
    },
  },
}
</script>

<style lang="scss">
.left-chart-2 {
  width: 100%;
  height: 50%;
  display: flex;
  flex-direction: column;
}
</style>
